import { useState } from 'react'

const useErrorModal = () => {
  const [isVisible, setIsVisible] = useState(false)
  const [message, setMessage] = useState('')

  const showError = (msg) => {
    setMessage(msg)
    setIsVisible(true)
  }

  const closeError = () => {
    setIsVisible(false)
    setMessage('')
  }

  return { isVisible, message, showError, closeError }
}

export default useErrorModal
